import { apiClient } from '../instance';
import type {
  HelpdeskSettings,
  RoutingRule,
  SLAPolicy,
  OperatorScheduleEntry,
  EmailTestResponse,
} from '../../types/helpdeskSettingsInterfaces';

export const helpdeskSettingsApi = {
  // General settings (singleton)
  getSettings: () =>
    apiClient.get<HelpdeskSettings[]>('/helpdesk/settings/general/'),
  updateSettings: (data: Partial<HelpdeskSettings>) =>
    apiClient.patch<HelpdeskSettings>('/helpdesk/settings/general/1/', data),

  // Routing rules
  getRoutingRules: () =>
    apiClient.get<RoutingRule[]>('/helpdesk/settings/routing-rules/'),
  createRoutingRule: (data: Partial<RoutingRule>) =>
    apiClient.post<RoutingRule>('/helpdesk/settings/routing-rules/', data),
  updateRoutingRule: (id: number, data: Partial<RoutingRule>) =>
    apiClient.patch<RoutingRule>(`/helpdesk/settings/routing-rules/${id}/`, data),
  deleteRoutingRule: (id: number) =>
    apiClient.delete(`/helpdesk/settings/routing-rules/${id}/`),
  reorderRoutingRules: (order: number[]) =>
    apiClient.post('/helpdesk/settings/routing-rules/reorder/', { order }),

  // SLA policies
  getSLAPolicies: () =>
    apiClient.get<SLAPolicy[]>('/helpdesk/settings/sla-policies/'),
  createSLAPolicy: (data: Partial<SLAPolicy>) =>
    apiClient.post<SLAPolicy>('/helpdesk/settings/sla-policies/', data),
  updateSLAPolicy: (id: number, data: Partial<SLAPolicy>) =>
    apiClient.patch<SLAPolicy>(`/helpdesk/settings/sla-policies/${id}/`, data),
  deleteSLAPolicy: (id: number) =>
    apiClient.delete(`/helpdesk/settings/sla-policies/${id}/`),

  // Operator schedules
  getSchedules: (operatorId?: number) =>
    apiClient.get<OperatorScheduleEntry[]>('/helpdesk/settings/schedules/', {
      params: operatorId ? { operator: operatorId } : undefined,
    }),
  createSchedule: (data: Partial<OperatorScheduleEntry>) =>
    apiClient.post<OperatorScheduleEntry>('/helpdesk/settings/schedules/', data),
  updateSchedule: (id: number, data: Partial<OperatorScheduleEntry>) =>
    apiClient.patch<OperatorScheduleEntry>(`/helpdesk/settings/schedules/${id}/`, data),
  deleteSchedule: (id: number) =>
    apiClient.delete(`/helpdesk/settings/schedules/${id}/`),

  // Available operators for schedules
  getAvailableOperators: () =>
    apiClient.get<{ id: number; username: string; first_name: string; last_name: string; full_name: string }[]>(
      '/helpdesk/settings/schedules/available-operators/',
    ),

  // Email channel test
  testEmailConnection: (testType: 'imap' | 'smtp' | 'both' = 'both') =>
    apiClient.post<EmailTestResponse>('/helpdesk/settings/email-channel/', {
      test_type: testType,
    }),
};
